<template>
  <div class="container-throughput-main">
    <div class="container-selection-control">
      <div class="date-section" >
        <div style="flex-grow: 1;">
          <DateTimePicker :showTime="false" :value.sync="fromDatePicker" placeholder="From" :isRequired="true" :errorMessage.sync="fromDatePickerErrorMessage"/>
          <DateTimePicker :showTime="false" :value.sync="toDatePicker" placeholder="To" :isRequired="true" :errorMessage.sync="toDatePickerErrorMessage"/>
        </div>
        <div>
          <button @click="refreshClicked" style="height: fit-content">Refresh</button>
        </div>
      </div>

      <Dropdown placeholder="System" :items="system" itemKey="Application Name" :selectedObject.sync="selectedSystem" :isRequired="true" :errorMessage.sync="selectedSystemErrorMessage" style="margin: 10px 0"/>
      <Dropdown placeholder="Job Type" :items="jobType" itemKey="Description" :selectedObject.sync="selectedJob" :isRequired="true" :errorMessage.sync="selectedJobErrorMessage" style="margin: 10px 0"/>

      <div class="separator"></div>
      <Filters class="customer-filter" title="Customer" :tableData="customerData" itemKey="Customer Code" itemDesc="Customer Name"
        @confirmClicked="customerFilterConfirmClicked" />
      <Filters
        class="shprCsgn-filter"
        title="ShprCsgn"
        :tableData="shprCsgnData"
        itemKey="ShprCsgn Code"
        itemDesc="ShprCsgn Name"
        @confirmClicked="shprCsgnFilterConfirmClicked"
      />
    </div>

     <div class="main-content" >
      <div class="top-info-container">

        <div class="left-container" style="width: 100%">

          <div class="job-date-range">
            <span> Job Date:</span>
            <span> &nbsp;{{ fromDate }} to {{toDate}} </span>
          </div>

          <div>
            <span>System   &nbsp;: {{ selectedSystemInfo }}</span>
          </div>

          <div class="last-row-container">
            <span id="info-jobType">Job Type:&nbsp;{{selectedJobInfo}}</span>
          </div>

          <div class="middle-container">
            <span>Customer:&nbsp;</span>
            <span>{{ filteredCustomer.length == 0 ? 'ALL' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(',') }}</span> 
          </div>

          <div class="shprCsgn-container">
            <span>Shpr/Csgn:&nbsp;</span>
            <span>{{ filteredShprCsgn.length == 0 ? 'ALL' : filteredShprCsgn.map((shprCsgn) => { return shprCsgn['ShprCsgn Code'] }).join(',')}}</span>
          </div>

        </div>

        <div class="right-container"> 
          <span style="margin-left: 10px">Last Refreshed: {{refreshDate}}</span>
        </div>

      </div>

      <div class="middle-chart-table">

        <div class="pie-chart-container">
          <div class="pie-chart-title">TEUs by Job Type</div>
          <div class="chart-body">
            <div class="custom-legend-container" id="legend" :style="{'width': chartPie != null ? '80px' : '0'}"></div>
            <div class="pie-chart" id="pie-chart" :style="{'width': chartPie != null ? 'calc(100% - 80px)' : '100%'}"></div>
          </div>
        </div>

        <div class="pie2-chart-container">
          <div class="pie2-chart-title">TEUs by Container Type</div>
          <div class="chart2-body">
            <div class="custom-legend2-container" id="legend2" :style="{'width': chartPie2 != null ? '100px' : '0'}"></div>
            <div class="pie2-chart" id="pie2-chart" :style="{'width': chartPie2 != null ? 'calc(100% - 100px)' : '100%'}"></div>
          </div>
        </div>

        <div class="barline-chart-container">
          <div class="barline-chart-title">
            Monthly Container Throughput 
            <img class="interactable-chart-indicator" src="https://dsmapi.logistics.systems/dsm6gicons/clickable.png"/>
          </div>
          <div class="barline-chart" id="barline-chart"></div>
          <div class="barline2-chart" id="barline2-chart"></div>
        </div>
      </div>

      <div class="bottom-chart-table">
        <div class="bar-chart-container">
          <div class="bar-chart-title">TEUs by Top 50 Shipper/Consignee</div>
          <div class="bar-chart" id="bar-chart"></div>
        </div>
      </div>
    </div>

    <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="drillThroughClicked('BY_MONTH_SZTYPE')" ref="context"/>

  </div>
</template>

<script>
/* eslint-disable */

export default {
  data: function() {
    return {
      selectedSystem: null,
      selectedSystemErrorMessage: "",
      selectedJob: null,
      selectedJobErrorMessage: "",
      selectedSystemInfo: "",

      selectedJobInfo: "",
      typeCust: "",

      fromDate: null,
      toDate: null, 
      fromDatePicker: new Date((new Date()).getFullYear(), 0, 1),
      fromDatePickerErrorMessage: "",
      toDatePicker: new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0), 
      toDatePickerErrorMessage: "", 
      refreshDate: (new Date()).formatString('dd/MM/yyyy HH:mm'),

      system: [],
      jobType: [],

      chartJobType: [],
      chartContType: [],
      chartByMonth: [],
      chartShprCsgn: [],

      chartPie: null,
      chartPie2: null,
      chartBar: null,
      chartLine: null,
      chartBar2: null,

      customerData: [],
      selectedCustomer: [],
      filteredCustomer: [],

      shprCsgnData: [],
      selectedShprCsgn: [],
      filteredShprCsgn: [],

      showContextMenu: false,
      contextItems: [],
      contextPosition: [ 100, 100 ],
    };
  },
  props: {
    // selectedSystem: { type: Object, default: function() { return null } },
    // selectedJob: { type: Object, default: function() { return null } },
    // selectedSystemInfo: { type: String, default: '' },

    // selectedJobInfo: { type: String, default: '' },
    // typeCust: { type: String, default: '' },

    // fromDate: { type: Date, default: null },
    // toDate: { type: Date, default: null }, 
    // fromDatePicker: { type: Date, default: new Date((new Date()).getFullYear(), 0, 1) },
    // toDatePicker: { type: Date, default: new Date((new Date()).getFullYear(), (new Date()).getMonth()+1, 0) }, 
    // refreshDate: { type: Date, default: new Date() },

    // system: {type: Array, default: function() { return [] } },
    // jobType: {type: Array, default: function() { return [] } },

    // chartJobType: {type: Array, default: function() { return [] } },
    // chartContType: {type: Array, default: function() { return [] } },
    // chartByMonth: {type: Array, default: function() { return [] } },
    // chartShprCsgn: {type: Array, default: function() { return [] } },

    // loading: { type: Boolean, default: false },

    // chartPie: { type: Object, default: function() { return null } },
    // chartPie2: { type: Object, default: function() { return null } },
    // chartBar: { type: Object, default: function() { return null } },
    // chartLine: { type: Object, default: function() { return null } },
    // chartBar2: { type: Object, default: function() { return null } },

    // customerData: { type: Array, default: function() { return [] } },
    // selectedCustomer: { type: Array, default: function() { return [] } },
    // filteredCustomer: { type: Array, default: function() { return [] } },

    // showContextMenu: { type: Boolean, default: false },
    // contextItems: { type: Array, default: function() { return [] } },
    // contextPosition: { type: Array, default: function() { return [ 100, 100 ] } },
  },
  components: {
  },
  methods: {
    customerFilterConfirmClicked: function(items) {
      this.selectedCustomer = items;
    },
    shprCsgnFilterConfirmClicked: function(shprCsgn) {
      this.selectedShprCsgn = shprCsgn;
    },
    refreshClicked: async function() {
      let missingRequired = false;

      if (!this.selectedSystem) {
        // this.$alert.showAlert('Invalid System', 'Please select a valid System from the dropdown list', 'error');
        this.selectedSystemErrorMessage = "System required";
        missingRequired = true;
      }

      if (!this.selectedJob) {
        // this.$alert.showAlert('Invalid Job Type', 'Please select a valid Job Type from the dropdown list', 'error');
        this.selectedJobErrorMessage = "Job type required";
        missingRequired = true;
      }

      if (!this.fromDatePicker) {
        this.fromDatePickerErrorMessage = "From date required";
        missingRequired = true;
      }

      if (!this.toDatePicker) {
        this.toDatePickerErrorMessage = "To date required";
        missingRequired = true;
      }

      if (missingRequired) {
        return;
      }

      this.$fullscreenLoading("Loading");
      this.fromDate = this.fromDatePicker.formatString('yyyy-MM-dd');
      this.toDate = this.toDatePicker.formatString('yyyy-MM-dd');
      this.selectedSystemInfo = this.selectedSystem['Application Name'];
      this.selectedJobInfo = this.selectedJob['Description'];

      this.filteredCustomer = this.selectedCustomer;
      var getCustomerCode = this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => { return c['Customer Code'] }).join(',');

      this.filteredShprCsgn = this.selectedShprCsgn;
      const shprCsgnArray = this.selectedShprCsgn.length == 0 ? '' : this.selectedShprCsgn.map((shprCsgn) => { return shprCsgn['ShprCsgn Code'] }).join(',');

      if(this.selectedJobInfo == ' '){
        this.selectedJobInfo = "ALL";
      }

      // this.jobType = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterFile=jobtype&modul=${ this.selectedSystem.System }`);
      // var length = this.jobType.length;
      // this.jobType[length] = { "Job Type":' ', "Description": 'ALL', "#": length + 1 };


      this.chartJobType = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.fromDatePicker.formatString('yyyy-MM-dd')}&end=${this.toDatePicker.formatString('yyyy-MM-dd')}&rptType=BY_JOBTYPE&sys=${ this.selectedSystem.System }&jobType=${ this.selectedJob['Job Type'] }&customerArray=${ getCustomerCode }&shprCsgnArray=${shprCsgnArray}`);

      this.chartContType = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.fromDatePicker.formatString('yyyy-MM-dd')}&end=${this.toDatePicker.formatString('yyyy-MM-dd')}&rptType=BY_CONTTYPE&sys=${ this.selectedSystem.System }&jobType=${ this.selectedJob['Job Type'] }&customerArray=${ getCustomerCode }&shprCsgnArray=${shprCsgnArray}`);

      this.chartByMonth = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.fromDatePicker.formatString('yyyy-MM-dd')}&end=${this.toDatePicker.formatString('yyyy-MM-dd')}&rptType=BY_MONTH&sys=${ this.selectedSystem.System }&jobType=${ this.selectedJob['Job Type'] }&customerArray=${ getCustomerCode }&shprCsgnArray=${shprCsgnArray}`);

      this.chartShprCsgn = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.fromDatePicker.formatString('yyyy-MM-dd')}&end=${this.toDatePicker.formatString('yyyy-MM-dd')}&rptType=BY_SHPRCSGN&sys=${ this.selectedSystem.System }&jobType=${ this.selectedJob['Job Type'] }&customerArray=${ getCustomerCode }&shprCsgnArray=${shprCsgnArray}&showTopx=50`);

      this.$fullscreenLoading("");
      this.refreshDate = (new Date()).formatString('dd/MM/yyyy HH:mm');

      if(this.chartJobType.length){
        var dynamicSeriesName = Object.keys(this.chartJobType[0]).filter((o) => { return o != 'Country_Name' && o != 'Port_Name' && o != 'TEUPerc' && o != 'Total20' && o != 'Total40' && o != 'XAxis' && o != 'XAxisDesc' });
        var dynamicSeries = this.chartJobType.map((p) => { return p[dynamicSeriesName] });
        var data = {
          series: dynamicSeries
        };
      }

      var sum = function(a, b) { return a + b };

      if (this.chartPie != null) {
        this.chartPie.detach();
        this.chartPie = null; // set to null so that styling will update dynamically
      }

      if (this.chartPie2 != null) {
        this.chartPie2.detach();
        this.chartPie2 = null;
      }

      if (this.chartBar != null) {
        this.chartBar.detach();
        this.chartBar = null;
      }

      if (this.chartLine != null) {
        this.chartLine.detach();
        this.chartLine = null;
      }
      
      if (this.chartBar2 != null) {
        this.chartBar2.detach();
        this.chartBar2 = null;
      }

      document.getElementById('legend').innerHTML = "";
      document.getElementById('pie-chart').innerHTML = "";

      document.getElementById('legend2').innerHTML = "";
      document.getElementById('pie2-chart').innerHTML = "";

      document.getElementById('barline-chart').innerHTML = "";
      document.getElementById('barline2-chart').innerHTML = "";

      document.getElementById('bar-chart').innerHTML = "";

      if (this.chartJobType.includes('error')) {
        document.getElementById('pie-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px; width: 100%\">An error occurred. Please try again.</div>"; 
      } else if (!this.chartJobType.length) {
        document.getElementById('pie-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px; width: 100%\">No records found.</div>";
      } else {
        if(this.chartJobType.length){
          var someDiv = document.getElementById('legend');
          this.chartPie = new Chartist.Pie('.pie-chart', data,
          {
            chartPadding: 40,
            fullWidth: true,
            plugins: [Chartist.plugins.legend({
              position: someDiv,
              legendNames: this.chartJobType.map((j) => { return j['XAxisDesc'] } ),
              clickable: false,
              className: "pieChart1"
            })],
            labelInterpolationFnc: function(value) {
              return Math.round(value / data.series.reduce(sum) * 100) + '%';
            },
          }
          );
        }
      }
      
      if (this.chartContType.includes('error')) {
        document.getElementById('pie2-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px; width: 100%\">An error occurred. Please try again.</div>";
      } else if (!this.chartContType.length) {
        document.getElementById('pie2-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px; width: 100%\">No records found.</div>";
      } else {
        if (this.chartContType.length) {
          var someDiv2 = document.getElementById('legend2');
          var dynamicSeriesName2 = Object.keys(this.chartContType[0]).filter((o) => { return o != 'Country_Name' && o != 'Port_Name' && o != 'TEUPerc' && o != 'Total20' && o != 'Total40' && o != 'XAxis' && o != 'XAxisDesc' });
          var dynamicSeries2 = this.chartContType.map((p) => { return p[dynamicSeriesName2] });
          var data2 = {
            series: dynamicSeries2
          };
        
          this.chartPie2 = new Chartist.Pie('.pie2-chart', data2,
          {
            chartPadding: 30,
            fullWidth: true,
            plugins: [Chartist.plugins.legend({
              position: someDiv2,
              legendNames: this.chartContType.map((j) => { return j['XAxisDesc'] } ),
              clickable: false,
              className: "pieChart2"
            })],
            labelInterpolationFnc: function(value) {
              return Math.round(value / data2.series.reduce(sum) * 100) + '%';
            }
          }
          );
        }
      }

      if (this.chartByMonth.includes('error')) {
        document.getElementById('barline-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      } else if (!this.chartByMonth.length) {
        document.getElementById('barline-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      } else {
        if (this.chartByMonth.length) {
          var dynamicSeriesName3 = Object.keys(this.chartByMonth[0]).filter((o) => { return o != 'Country_Name' && o != 'Port_Name' && o != 'TEUPerc' && o != 'TEUs' && o != 'XAxis' && o != 'XAxisDesc' });
          var dynamicSeries3 = dynamicSeriesName3.map((d) => {
            return {
              name: d,
              data: this.chartByMonth.map((p) => { return p[d] })
            }
          });
        
          var value = dynamicSeriesName3.map((d) => {
            return {
              data: Math.max(...this.chartByMonth.map((p) => { return p[d] })),
              data1: Math.min(...this.chartByMonth.map((p) => { return p[d] }))
            }
          });
          var maxValue = Math.max(...value.map((p) => { return p.data }));
          var minValue = Math.min(...value.map((p) => { return p.data1 }));
        }

        if(this.chartByMonth.length){
          var dynamicSeriesName4 = Object.keys(this.chartByMonth[0]).filter((o) => { return o != 'Country_Name' && o != 'Port_Name' && o != 'TEUPerc' && o != 'Total20' && o != 'Total40' && o != 'XAxis' && o != 'XAxisDesc' });
          var dynamicSeries4 = dynamicSeriesName4.map((d) => {
            return {
              name: d,
              data: this.chartByMonth.map((p) => { return p[d] })
            }
          });
        
          var value2 = dynamicSeriesName4.map((d) => {
            return {
              data: Math.max(...this.chartByMonth.map((p) => { return p[d] })),
              data1: Math.min(...this.chartByMonth.map((p) => { return p[d] }))
            }
          });
          var maxValue2 = Math.max(...value2.map((p) => { return p.data }));
          var minValue2 = Math.min(...value2.map((p) => { return p.data1 }));
          var maxValue2Chart = Math.max(maxValue, maxValue2);
          var minValue2Chart = Math.min(minValue, minValue2);
        
          this.chartBar = new Chartist.Bar('.barline-chart', {
            labels: this.chartByMonth.map((m) => { return m['XAxisDesc'] } ),
            series: dynamicSeries3
          }, {
            chartPadding: {top: 30, right: 10, bottom: 0, left: 10},
            low: minValue2Chart,
            high: maxValue2Chart,
            fullWidth: true,
            plugins: [Chartist.plugins.legend({position: 'top',className: "barlineChart",})]
          });
        
        
          this.chartLine = new Chartist.Line('.barline2-chart', {
            labels: this.chartByMonth.map((m) => { return m['XAxisDesc'] } ),
            series: dynamicSeries4
          }, {
            low: minValue2Chart,
            high: maxValue2Chart,
            chartPadding: {top: 30, right: 10, bottom: 0, left: 10},
            axisY: {showGrid: false, showLabel: false},
            axisX: { showGrid: false, showLabel: false },
            fullWidth: true,
            plugins: [Chartist.plugins.legend({position: 'top', className: "barline2Chart",})]
          });
        }
      }

      if (this.chartShprCsgn.includes('error')) {
        document.getElementById('bar-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
      } else if (!this.chartShprCsgn.length) {
        document.getElementById('bar-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
      } else {
        if (this.chartShprCsgn.length) {
          var dynamicSeriesName5 = Object.keys(this.chartShprCsgn[0]).filter((o) => { return o != 'XAxis' && o != 'XAxisDesc' && o != 'XAxisDesc_ranking' });
          var dynamicSeries5 = this.chartShprCsgn.map((p) => { return { name: dynamicSeriesName5, meta: `TEUs|${p['XAxis']}|${p['XAxisDesc']}`, value: p[dynamicSeriesName5] } } ) ;
        
          this.chartBar2 = new Chartist.Bar('.bar-chart', {
            labels: this.chartShprCsgn.map((m) => { return m['XAxis'] } ),
            series: [dynamicSeries5]
          }, {
            chartPadding: {top: 30,right: 30,bottom: 0,left: 30},
            axisY: {offset: 10, scaleMinSpace: 0},
            axisX: {},
            fullWidth: true,
            plugins: [
              Chartist.plugins.legend({legendNames: ['TEUs'], position: 'top', className: "barChart",}), 
            ]
          });
        }
      }
      this.createTooltips();
    },
    createTooltips: function(){
      var $tooltip = $('<div class="tooltip tooltip-hidden"></div>').appendTo($('.bar-chart'));
      $(document).on('mouseenter', '.ct-bar', function() {
        var seriesName = $(this).closest('.ct-bar').attr('ct:meta'),
        value = $(this).attr('ct:value');
        $tooltip.html(`<span>${seriesName.split('|')[1]}</span><br /><span>${seriesName.split('|')[2]}</span><br /><br /><span>${seriesName.split('|')[0]}: ${$(this).attr('ct:value')}</span>`);
        $tooltip.removeClass('tooltip-hidden');
      });

      $(document).on('mouseleave', '.ct-bar', function() {
        $tooltip.addClass('tooltip-hidden');
      });

      $(document).on('mousemove', '.ct-bar', function(event) {
        $tooltip.css({
          left: event.pageX + 5,
          top: event.pageY - 140
        });
      });

      var $tooltipLine = $('<div class="tooltip tooltip-hidden"></div>').appendTo($('.barline2-chart'));

      $(document).on('mouseenter', '.ct-point', function() {
        var seriesName = $(this).closest('.ct-series').attr('ct:series-name'),
        value = $(this).attr('ct:value');
        $tooltipLine.html("<span>" + seriesName + "<br/> " + value + "</span>");
        $tooltipLine.removeClass('tooltip-hidden');
      });

      $(document).on('mouseleave', '.ct-point', function() {
        $tooltipLine.addClass('tooltip-hidden');
      });

      $(document).on('mousemove', '.ct-point', function(event) {
        $tooltipLine.css({
          left: (event.offsetX || event.originalEvent.layerX) - $tooltipLine.width() / 2,
          top: (event.offsetY || event.originalEvent.layerY) - $tooltipLine.height() - 20
        });
      });

      var mainContainer = this;
        $('document').ready(() => {
          $(document).on('click', '.barline2-chart .ct-point', function(e) {
            mainContainer.showContextMenu = true;
            mainContainer.contextItems = [ 'Monthly Container Throughput Report' ];
            
            mainContainer.$nextTick(() => {
              mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 0), e.clientX + 15];
            });
          });
        });
    },
    drillThroughClicked: async function(rptType) {
      this.$fullscreenLoading("Loading");

      var system = this.selectedSystem.System ? this.selectedSystem.System.trim() : '';
      var jobtype = this.selectedJob ? this.selectedJob['Job Type'] : '';
      var customerarray = this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => { return c['Customer Code'] }).join(',');
      const shprCsgnArray = this.selectedShprCsgn.length == 0 ? '' : this.selectedShprCsgn.map((shprCsgn) => { return shprCsgn['ShprCsgn Code'] }).join(',');

      var filterData = {
        'fromDate': this.fromDate,
        'toDate': this.toDate,
        'system': this.selectedSystem ? this.selectedSystem['Application Name'] : '',
        'jobtype': this.selectedJob ? this.selectedJob['Description'] : '',
        'customer': customerarray,
        'shprCsgn': shprCsgnArray,
        'refreshDate': this.refreshDate,
      };

      switch (rptType) {
        case 'BY_MONTH_SZTYPE':
          var drillThrough = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.fromDatePicker.formatString('yyyy-MM-dd')}&end=${this.toDatePicker.formatString('yyyy-MM-dd')}&rptType=${rptType}&sys=${system}&jobType=${jobtype}&customerArray=${customerarray}&shprCsgnArray=${shprCsgnArray}`);
          sessionStorage.setItem(`Drill Through - Monthly Container Throughput`, JSON.stringify({ filter: filterData, data: drillThrough, rptType : rptType }));
          var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Container Throughput/Drill Through - Monthly Container Throughput`);
          window.open(drillThroughLink.href, '_blank');
          break;
        default:
          break;
      }
      sessionStorage.clear();

      this.$fullscreenLoading("");
    },
  },
  async mounted() {
    this.$fullscreenLoading("Loading");
    this.fromDate = this.fromDatePicker.formatString('yyyy-MM-dd');
    this.toDate = this.toDatePicker.formatString('yyyy-MM-dd');

    this.system = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterFile=SYSTEM`);
    this.selectedSystem = this.system[0];
    this.selectedSystemInfo = this.selectedSystem['Application Name'];

    this.jobType = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterFile=jobtype&modul=${ this.selectedSystem.System }`);
    var length = this.jobType.length;
    this.jobType[length] = { "Job Type":' ', "Description": 'ALL', "#": length + 1 };
    this.selectedJob = this.jobType[length];
    this.selectedJobInfo = this.selectedJob['Description'];

    if(this.selectedJobInfo == ' '){
      this.selectedJobInfo = "ALL";
    }

    this.customerData = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterFile=BILLCUSTNAME&modul=null`);

    this.shprCsgnData = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterfile=SHPRCSGNNAME&modul=null`);

    this.chartJobType = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.fromDatePicker.formatString('yyyy-MM-dd')}&end=${this.toDatePicker.formatString('yyyy-MM-dd')}&rptType=BY_JOBTYPE&sys=${ this.selectedSystem.System }&jobType=${ this.selectedJob['Job Type'] }&customerArray=&shprCsgnArray=`);

    this.chartContType = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.fromDatePicker.formatString('yyyy-MM-dd')}&end=${this.toDatePicker.formatString('yyyy-MM-dd')}&rptType=BY_CONTTYPE&sys=${ this.selectedSystem.System }&jobType=${ this.selectedJob['Job Type'] }&customerArray=&shprCsgnArray=`);

    this.chartByMonth = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.fromDatePicker.formatString('yyyy-MM-dd')}&end=${this.toDatePicker.formatString('yyyy-MM-dd')}&rptType=BY_MONTH&sys=${ this.selectedSystem.System }&jobType=${ this.selectedJob['Job Type'] }&customerArray=&shprCsgnArray=`);

    this.chartShprCsgn = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.fromDatePicker.formatString('yyyy-MM-dd')}&end=${this.toDatePicker.formatString('yyyy-MM-dd')}&rptType=BY_SHPRCSGN&sys=${ this.selectedSystem.System }&jobType=${ this.selectedJob['Job Type'] }&customerArray=&shprCsgnArray=&showTopx=50`);

    this.$fullscreenLoading("");

    if (this.chartJobType.includes('error')) {
      document.getElementById('pie-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px; width: 100%\">No records found.</div>";
    } else if (!this.chartJobType.length) {
      document.getElementById('pie-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px; width: 100%\">No records found.</div>";
    } else {
      this.refreshDate = (new Date()).formatString('dd/MM/yyyy HH:mm');

      var dynamicSeriesName = Object.keys(this.chartJobType[0]).filter((o) => { return o != 'Country_Name' && o != 'Port_Name' && o != 'TEUPerc' && o != 'Total20' && o != 'Total40' && o != 'XAxis' && o != 'XAxisDesc' });
      var dynamicSeries = this.chartJobType.map((p) => { return p[dynamicSeriesName] });

      var someDiv = document.getElementById('legend');
      var data = {
        series: dynamicSeries
      };
      var sum = function(a, b) { return a + b };
      this.chartPie = new Chartist.Pie('.pie-chart', data,
      {
        chartPadding: 40,
        plugins: [Chartist.plugins.legend({
          position: someDiv,
          legendNames: this.chartJobType.map((j) => { return j['XAxisDesc'] } ),
          clickable: false,
          className: "pieChart1"
        })],
        labelInterpolationFnc: function(value) {
          return Math.round(value / data.series.reduce(sum) * 100) + '%';
        },
      }
      );
    }

    if (this.chartContType.includes('error')) {
      document.getElementById('pie2-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px; width: 100%\">No records found.</div>";
    } else if (!this.chartContType.length) {
      document.getElementById('pie2-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px; width: 100%\">No records found.</div>";
    } else {
      var dynamicSeriesName2 = Object.keys(this.chartContType[0]).filter((o) => { return o != 'Country_Name' && o != 'Port_Name' && o != 'TEUPerc' && o != 'Total20' && o != 'Total40' && o != 'XAxis' && o != 'XAxisDesc' });
      var dynamicSeries2 = this.chartContType.map((p) => { return p[dynamicSeriesName2] });

      var data2 = {
        series: dynamicSeries2
      };
      var someDiv2 = document.getElementById('legend2');
      this.chartPie2 = new Chartist.Pie('.pie2-chart', data2,
      {
        chartPadding: 30,
        plugins: [Chartist.plugins.legend({
          position: someDiv2,
          legendNames: this.chartContType.map((j) => { return j['XAxisDesc'] } ),
          clickable: false,
          className: "pieChart2"
        })],
        labelInterpolationFnc: function(value) {
          return Math.round(value / data2.series.reduce(sum) * 100) + '%';
        }
      }
      );
    }
    
    if(this.chartByMonth.includes('error'))
      document.getElementById('barline-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
    else if(!this.chartByMonth.length)
      document.getElementById('barline-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
    else{
      var dynamicSeriesName3 = Object.keys(this.chartByMonth[0]).filter((o) => { return o != 'Country_Name' && o != 'Port_Name' && o != 'TEUPerc' && o != 'TEUs' && o != 'XAxis' && o != 'XAxisDesc' });
      var dynamicSeries3 = dynamicSeriesName3.map((d) => {
        return {
          name: d,
          data: this.chartByMonth.map((p) => { return p[d] })
        }
      });
      var value = dynamicSeriesName3.map((d) => {
        return {
          data: Math.max(...this.chartByMonth.map((p) => { return p[d] })),
          data1: Math.min(...this.chartByMonth.map((p) => { return p[d] }))
        }
      });
      var maxValue = Math.max(...value.map((p) => { return p.data }));
      var minValue = Math.min(...value.map((p) => { return p.data1 }));

      var dynamicSeriesName4 = Object.keys(this.chartByMonth[0]).filter((o) => { return o != 'Country_Name' && o != 'Port_Name' && o != 'TEUPerc' && o != 'Total20' && o != 'Total40' && o != 'XAxis' && o != 'XAxisDesc' });
      var dynamicSeries4 = dynamicSeriesName4.map((d) => {
        return {
          name: d,
          data: this.chartByMonth.map((p) => { return p[d] })
        }
      });
      var value2 = dynamicSeriesName4.map((d) => {
        return {
          data: Math.max(...this.chartByMonth.map((p) => { return p[d] })),
          data1: Math.min(...this.chartByMonth.map((p) => { return p[d] }))
        }
      });
      var maxValue2 = Math.max(...value2.map((p) => { return p.data }));
      var minValue2 = Math.min(...value2.map((p) => { return p.data1 }));
      var maxValue2Chart = Math.max(maxValue, maxValue2);
      var minValue2Chart = Math.min(minValue, minValue2);

      this.chartBar = new Chartist.Bar('.barline-chart', {
        labels: this.chartByMonth.map((m) => { return m['XAxisDesc'] } ),
        series: dynamicSeries3
      }, {
        chartPadding: {top: 30, right: 10, bottom: 0, left: 10},
        low: minValue2Chart,
        high: maxValue2Chart,
        fullWidth: true,
        plugins: [Chartist.plugins.legend({
          className: "barlineChart",
          position: "top",
        })]
      });

      this.chartLine = new Chartist.Line('.barline2-chart', {
        labels: this.chartByMonth.map((m) => { return m['XAxisDesc'] } ),
        series: dynamicSeries4
      }, {
        low: minValue2Chart,
        high: maxValue2Chart,
        chartPadding: {top: 30, right: 10, bottom: 0, left: 10},
        axisY: {showGrid: false, showLabel: false},
        axisX: { showGrid: false, showLabel: false },
        fullWidth: false,
        plugins: [Chartist.plugins.legend({
          className: "barline2Chart",
          position: 'top'
        })]
      });
    }

    if(this.chartShprCsgn.includes('error'))
      document.getElementById('bar-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px;\">An error occurred. Please try again.</div>";
    else if(!this.chartShprCsgn.length)
      document.getElementById('bar-chart').innerHTML = "<div style=\"text-align: center; font-weight: bold; font-size: 10px;\">No records found.</div>";
    else{
      var dynamicSeriesName5 = Object.keys(this.chartShprCsgn[0]).filter((o) => { return o != 'XAxis' && o != 'XAxisDesc' && o != 'XAxisDesc_ranking' });
      var dynamicSeries5 = this.chartShprCsgn.map((p) => { return { name: dynamicSeriesName5, meta: `TEUs|${p['XAxis']}|${p['XAxisDesc']}`, value: p[dynamicSeriesName5] } } ) ;

      this.chartBar2 = new Chartist.Bar('.bar-chart', {
        labels: this.chartShprCsgn.map((m) => { return m['XAxis'] } ),
        series: [dynamicSeries5]
      }, {
        chartPadding: {top: 30,right: 30,bottom: 0,left: 30},
        axisY: {offset: 10, scaleMinSpace: 0},
        axisX: {},
        fullWidth: true,
        plugins: [
          Chartist.plugins.legend({
            legendNames: ['TEUs'], 
            position: 'top',
            className: "barChart",
          }), 
        ]
      });
    }
    this.createTooltips();
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

button.drillthrough-button{
  background: white; 
  outline: none; 
  padding: 0; 
  position:  absolute;
  top: 4px;
  right: 7px;

  :hover {
    background: white;
    outline: none; 
  }
}

.container-throughput-main {
  font-size: 12px;
  height: 100%;
  width: 100%;
  padding: 5px 45px;
  display: flex;

  > .container-selection-control{
    font-size: 12px;
    // border: 1px solid rgb(200,200,200);
    border-radius: 5px;
    padding: 5px;
    height: 100%;
    min-width: 300px;
    margin-right: 5px;
    background-color: white;

    >.date-section{
      display: flex;
      align-items: center;
    }

    > .separator {
      height: 1px;
      width: 100%;
      margin: 3px;
    }

    > .customer-filter {
      height: calc(50% - 140px);
    }

    > .shprCsgn-filter {
      height: calc(50% - 140px);
    }
  }

  > .main-content{
    width: calc(100% - 300px);
    font-size: 12px;

    > .top-info-container{
      width: 100%;
      height: 100px;
      padding: 5px 10px 5px 5px;
      display: flex;
      border-radius: 5px;
      background-color: white;

      >.left-container{
        >.job-date-range{
          display: flex;
          flex-wrap: wrap;
        }

        >.last-row-container{
          display: flex;
          height: 15px;
        }

        >.middle-container{
          overflow: hidden; 
          text-overflow: ellipsis;
          width: 75%;
        }

      }

      >.right-container{
        // position: absolute;
        min-width: 250px;
        height: 100%;
        right: 50px;
        top: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        > button {
          width: fit-content;
          margin: 3px 0;
        }
      }
    }

    >.middle-chart-table{
      width: 100%;
      height: calc(55% - 90px);
      display: flex;
      margin-top: 3px;

      >.pie-chart-container{
        height: 100%;
        width: 30%;
        border-radius: 5px;
        background-color: white;
        
        >.pie-chart-title{
          width: 100%;
          height: 20px;
          font-size: 12px; 
          font-weight: bold;
          text-align: center;
        }

        > .chart-body{
          width: 100%;
          height: calc(100% - 20px);
          display: flex;

          >.pie-chart{
            height: 100%;
          }

          >.custom-legend-container{
            height: 100%;
          }
        }
      }

      >.pie2-chart-container{
        height: 100%;
        width: 30%;
        margin-left: 3px;
        border-radius: 5px;
        background-color: white;
        
        >.pie2-chart-title{
          width: 100%;
          height: 20px;
          font-size: 12px; 
          font-weight: bold;
          text-align: center;
        }

        > .chart2-body{
          width: 100%;
          height: calc(100% - 20px);
          display: flex;

          >.pie2-chart{
            height: 100%;
          }

          >.custom-legend2-container{
            height: 90%;
            // margin-right: -45px; // notq
          }
        }
      }

      >.barline-chart-container{
        height: 100%;
        width: calc(100% - 60%);
        border-radius: 5px;
        background-color: white;
        margin-left: 3px;
        position: relative;

        >.barline-chart-title{
          width: 100%;
          height: 20px;
          font-size: 12px; 
          font-weight: bold;
          text-align: center;

          >.interactable-chart-indicator {
            height: 22px;
            width: 22px;
            position: absolute;
            top: 3px;
            right: 3px;
          }
        }

        >.barline-chart{
          width: 100%;
          height: calc( 100% - 20px);
        }

        >.barline2-chart{
          width: 100%;
          height: calc( 100% - 20px);
          position: absolute;
          bottom: 0px;
        }
      }
    }

    >.bottom-chart-table{
      margin-top: 3px;
      width: 100%;
      height: calc(45% - 10px);
      padding-bottom: 5px;
    
      >.bar-chart-container{
        width: 100%;
        height: 100%;
        border-radius: 5px;
        background-color: white;

        >.bar-chart-title{
          width: 100%;
          height: 20px;
          font-size: 12px; 
          font-weight: bold;
          text-align: left;
          margin-left: 5px;
        }

        >.bar-chart{
          width: 100%;
          height: calc( 100% - 20px);
        }
      }
    }
  }
}
</style>